import { Ref, ref } from "vue";
import { saveAs } from 'file-saver';
import Encoding from 'encoding-japanese';

import { PxService } from "@/service/PxService";
import { DialogService } from "@/service/DialogService";
import { FileUtil } from "@/utils/FileUtil";

export function useCreate() {

    const isCreating = ref(false);
    // PXへ勤怠情報を登録するためのCSVダウンロード
    const downloadKintaiCSV = async (start:string, end:string) => {
        isCreating.value = true;
        const srv = new PxService();

        // ダウンロード
        DialogService.nowloading('CSVダウンロード中...');
        const res = await srv.downloadKintaiCSV(start, end)
        if (!res) {
            isCreating.value = false;
            DialogService.error({
                text: '予期せぬ事態が発生しダウンロードに失敗しました'
            }, true);
            return
        }

        // レスポンスからCSVファイルを生成
        try {
            saveAs(
                await FileUtil.createSjisBlob(res.data as string, res.headers["content-type"]),
                await FileUtil.getFileName(res.headers["content-disposition"])
            )
        } catch (e) {
            isCreating.value = false;
            DialogService.error({
                text: 'CSVファイルの作成に失敗しました'
            }, true);
            return
        }

        DialogService.info({
            text: `CSVをダウンロードしました`
        }, true);
        isCreating.value = false;
    }

    // PXの社員マスタへ登録するためのCSVダウンロード
    const downloadSyainCSV = async (userId: number, koyouKeiyakuId: number | null) => {
        isCreating.value = true;
        const srv = new PxService();

        // ダウンロード
        DialogService.nowloading('CSVダウンロード中...');
        const res = await srv.downloadSyainCSV(userId, koyouKeiyakuId)
        if (!res) {
            return
        }

        // レスポンスからCSVファイルを生成
        try {
            saveAs(
                await FileUtil.createSjisBlob(res.data as string, res.headers["content-type"]),
                await FileUtil.getFileName(res.headers["content-disposition"])
            )
        } catch (e) {
            DialogService.error({
                text: 'CSVファイルの作成に失敗しました'
            }, true);
            return
        }

        DialogService.info({
            text: `CSVをダウンロードしました`
        }, true);
        isCreating.value = false;
    }

    return {
        isCreating,
        downloadKintaiCSV,
        downloadSyainCSV
    }
}
